var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3536 6.56547C18.5488 6.37021 18.5488 6.05362 18.3536 5.85836C18.1583 5.6631 17.8417 5.6631 17.6464 5.85836L12 11.5048L6.35355 5.85836C6.15829 5.6631 5.84171 5.6631 5.64645 5.85836C5.45118 6.05362 5.45118 6.37021 5.64645 6.56547L11.2929 12.2119L5.64645 17.8584C5.45118 18.0536 5.45118 18.3702 5.64645 18.5655C5.84171 18.7607 6.15829 18.7607 6.35355 18.5655L12 12.919L17.6464 18.5655C17.8417 18.7607 18.1583 18.7607 18.3536 18.5655C18.5488 18.3702 18.5488 18.0536 18.3536 17.8584L12.7071 12.2119L18.3536 6.56547Z",
    fill: "#4D4E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b958a1da96c41ba650ca27f90f5ed408.svg";
export { ForwardRef as ReactComponent };